import PipeDealApi from 'api/pipedrive/deal';
import PipePersonApi from 'api/pipedrive/person';
import PipeOrganizationApi from 'api/pipedrive/organization';

class RequestBotHelper {
  static async requestBot(bot, me, obs) {
    let person = await PipePersonApi.findByEmail(me.email);
    let org = await PipeOrganizationApi.find(me.company.name);

    if (!person) {
      person = await PipePersonApi.create({
        name: me.name,
        email: [me.email],
        phone: me.phones,
      });
    }

    if (!org) {
      org = await PipeOrganizationApi.create({
        name: me.company.name,
      });
    }

    await PipeDealApi.create({
      title: `Solicitação do bot "${bot.name}"`,
      person_id: person.id,
      org_id: org.id,
      '35b1184f19c6511cd375396c58bd55d6ee4bbe9d': obs,
      // value: '<string>',
      // currency: '<string>',
    });
  }
}

export default RequestBotHelper;
